import React from "react";
import { UseFormReturn } from "react-hook-form";
import { Input } from "../../../components/form";
import { Button } from "../../../components/button";

interface IWarehouseForm {
  loading: boolean;
  form: UseFormReturn<any, any>;
  submit: any;
}

export const WarehouseForm: React.FC<IWarehouseForm> = ({
  loading,
  form,
  submit,
}) => {
  return (
    <div className="w-full">
      <div className="flex flex-wrap gap-3">
        <Input
          label="Nom"
          className="w-full"
          {...form.register("name", { required: "Nom requis" })}
        />
        <Input
          label="Adresse"
          className="w-full"
          {...form.register("address", { required: "Adresse requise" })}
        />
        <label className="w-full flex items-center gap-2">
          <input type="checkbox" {...form.register("active")} defaultChecked />
          <span className="text-sm">Actif</span>
        </label>
      </div>

      <div className="w-full mt-4">
        <Button onClick={submit} loading={loading} disabled={loading}>
          Valider
        </Button>
      </div>
    </div>
  );
};
